import React, { useState } from "react";
import PropTypes from "prop-types";
import Slider from "@material-ui/core/Slider";
import { classes } from "components/Utility";

export default function MSlider(props) {
  const [value, setValue] = useState(() => {
    const isRange = props.defaultValue && Array.isArray(props.defaultValue) && props.defaultValue.length === 2;
    const initialValue = isRange ? props.defaultValue.map(Number) : (props.defaultValue && !isNaN(props.defaultValue) ? parseFloat(props.defaultValue) : 0);
    if (props.onChangeCallback) props.onChangeCallback(initialValue.toString());
    return initialValue;
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (props.onChangeCallback) props.onChangeCallback(newValue.toString());
  };
  
  return (
    <div className={classes("mslider", props.className)}>
      <Slider
        classes={{
          root: "mslider"
        }}
        value={value}
        onChange={handleChange}
        marks={props.marks}
        max={props.max}
        min={props.min}
        step={props.step}
        valueLabelDisplay={"auto"}
        track={props.invertTrack ? "inverted" : "normal"}
      />
    </div>
  );
}

MSlider.propTypes = {
  className: PropTypes.string,
  onChangeCallback: PropTypes.func, // Use this to get the value after the slider is changed
  defaultValue: PropTypes.oneOfType([
    PropTypes.number,               // Passing a single number value (or string that can be parsed to a number) makes this a slider with a single handle
    PropTypes.string,
    PropTypes.array                 // Passing an array of number values makes this a range slider. It"s likely your range slider only needs 2 values.
  ]).isRequired,
  max: PropTypes.number.isRequired, // The max value of the slider
  min: PropTypes.number.isRequired, // The min value of the slider
  step: PropTypes.number.isRequired,// Sets the granularity of slider values.
  marks: PropTypes.array,           // Marks to show along the slider. Must be an array of objects: [{value: 1, label: "One"}, {value: 2, label: "Two"}]
  invertTrack: PropTypes.bool,      // Pass true to invert the direction of the slider track (the line the fills from the selection to end of the range)
};